module.exports = __webpack_public_path__ + "static/media/clock-icon.cf06d9ab.svg";